import {daysAgo} from './format';

export function quoteSheetIds(quote) {
  const ids=new Set();
  for(const line of quote?.lines||[]) {
    if(line.physical_sheet_id)ids.add(line.physical_sheet_id);
    const used=line.price_audit?.source_snapshot?.sheet?.id;
    if(used)ids.add(used);
  }
  return [...ids];
}

export function staleQuoteSheets(quote,sheets,warningDays=30) {
  const ids=new Set(quoteSheetIds(quote));
  return sheets.filter(sheet=>ids.has(sheet.id)&&daysAgo(sheet.price_date)!==null&&daysAgo(sheet.price_date)>warningDays);
}

export function sheetPriceText(cents) {
  if(!Number.isSafeInteger(cents)||cents<0)return '';
  const value=BigInt(cents);
  return `${value/100n}.${String(value%100n).padStart(2,'0')}`;
}

export function sheetReviewPayload(sheet,priceCents) {
  return {grade_id:sheet.grade_id,thickness_mm:sheet.thickness_mm,width_mm:sheet.width_mm,length_mm:sheet.length_mm,
    price_cents:priceCents,price_date:new Date().toISOString().slice(0,10),stock_status:sheet.stock_status||'unknown',
    supplier:sheet.supplier||'',pricing_method:sheet.pricing_method||'Per sheet',expected_updated_at:sheet.updated_at??null,
    confirm_price_review:true};
}
